import { render, staticRenderFns } from "./IndividualApplicant.vue?vue&type=template&id=0352c6c3"
import script from "./IndividualApplicant.vue?vue&type=script&lang=js"
export * from "./IndividualApplicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports